import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { RefreshToken, RefreshTokenCreate, RefreshTokenFilter } from '../data/refreshToken';

export function createRefreshTokenService(client: AxiosInstance) {
  return createCrudService<RefreshToken, RefreshTokenCreate, RefreshTokenFilter>(
    client,
    '/identity/RefreshToken',
    'id',
  );
}

export type RefreshTokenService = CrudService<RefreshToken, RefreshTokenCreate, RefreshTokenFilter>;
